/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Recipient_ListsInputs */

const en_nav_recipient_lists = /** @type {(inputs: Nav_Recipient_ListsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recipient lists`)
};

/**
* | output |
* | --- |
* | "Recipient lists" |
*
* @param {Nav_Recipient_ListsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_recipient_lists = /** @type {((inputs?: Nav_Recipient_ListsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Recipient_ListsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_recipient_lists(inputs)
});